import React from "react";
import ReactApexChart from "react-apexcharts";
import { Col, Row } from "react-bootstrap";

const ColumnChart = ({ graph }) => {
  const chartData = {
    series: [{ data: graph?.totalData || [], name: "Subject" }],
    options: {
      chart: {
        height: 350,
        type: "bar",
      },
      plotOptions: {
        bar: { dataLabels: { position: "top" } },
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
      },
      colors: graph?.categoryColor?.map(item => item?.color) ?? [],
      xaxis: {
        categories: graph?.totalCategory || []
      },
    },
  };

  return (
    <div>
      <div
        className="d-flex align-items-center justify-content-between graph__title__border bg-body-secondary"
        style={{ borderBottom: "1px solid rgb(229, 229, 229)" }}
      >
        <h6 className="m-0 fontSize12 fw-bold">
          {graph?.graphName || "Column Chart"}
        </h6>
      </div>
      <Row>
        <Col md={1} className="chart_yaxis_legend">
          <p className="fw-bold">{graph?.yAxisName}</p>
        </Col>
        <Col md={11}>
          <div id="chart" className="p-0">
            <ReactApexChart
              options={chartData.options}
              series={chartData.series}
              type="bar"
              height={350}
            />
          </div>
          <div className="chart_xaxis_legend">
            <p className="fw-bold">{graph?.xAxisName}</p>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ColumnChart;
